import type { CSSProperties } from 'react';
import type { CoverFocalPoint } from './api';

export const CENTER_COVER_FOCAL_POINT: CoverFocalPoint = { x: 50, y: 50 };

export function normalizeCoverFocalPoint(value: CoverFocalPoint | null | undefined): CoverFocalPoint {
  if (
    !value ||
    !Number.isFinite(value.x) || value.x < 0 || value.x > 100 ||
    !Number.isFinite(value.y) || value.y < 0 || value.y > 100
  ) {
    return { ...CENTER_COVER_FOCAL_POINT };
  }
  return { x: value.x, y: value.y };
}

export function coverFocalPointStyle(value: CoverFocalPoint | null | undefined): CSSProperties {
  const point = normalizeCoverFocalPoint(value);
  return { objectPosition: `${point.x}% ${point.y}%` };
}

export function dragCoverFocalPoint(
  start: CoverFocalPoint,
  delta: { x: number; y: number },
  frame: { width: number; height: number },
  media: { width: number; height: number }
): CoverFocalPoint {
  if (frame.width <= 0 || frame.height <= 0 || media.width <= 0 || media.height <= 0) {
    return normalizeCoverFocalPoint(start);
  }
  const scale = Math.max(frame.width / media.width, frame.height / media.height);
  const overflowX = Math.max(0, media.width * scale - frame.width);
  const overflowY = Math.max(0, media.height * scale - frame.height);
  return {
    x: overflowX > 0 ? roundAndClamp(start.x - delta.x / overflowX * 100) : start.x,
    y: overflowY > 0 ? roundAndClamp(start.y - delta.y / overflowY * 100) : start.y
  };
}

export function nudgeCoverFocalPoint(
  point: CoverFocalPoint,
  key: 'ArrowLeft' | 'ArrowRight' | 'ArrowUp' | 'ArrowDown',
  amount: number
): CoverFocalPoint {
  const next = { ...normalizeCoverFocalPoint(point) };
  if (key === 'ArrowLeft') next.x = roundAndClamp(next.x - amount);
  if (key === 'ArrowRight') next.x = roundAndClamp(next.x + amount);
  if (key === 'ArrowUp') next.y = roundAndClamp(next.y - amount);
  if (key === 'ArrowDown') next.y = roundAndClamp(next.y + amount);
  return next;
}

function roundAndClamp(value: number): number {
  return Math.round(Math.min(100, Math.max(0, value)) * 100) / 100;
}
